<template>
  <button
    class="btn-Product container"
    @click="$emit('click', product)"
  >
    <div class="marco-imagen">
      <v-img
        :src="imagenPrincipal"
        cover
        :aspect-ratio="4 / 3"
        class="imagen"
      >
        <template #placeholder>
          <div class="cargando-imagen">
            <v-progress-circular
              indeterminate
              color="grey-lighten-1"
              size="22"
            />
          </div>
        </template>
      </v-img>
    </div>

    <div class="cuerpo">
      <div class="titulo">{{ product.product }}</div>

      <div class="precio">
        {{ precioFormateado }}
        <span class="moneda">COP</span>
      </div>

      <div
        v-if="product.description"
        class="descripcion"
      >
        {{ product.description }}
      </div>
    </div>
  </button>
</template>

<script>
import apisProducts from '@/apis/apisProducts';
import imagenPorDefecto from '@/assets/imagen-none.jpg';

export default {
  name: 'ComponentProduct',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  emits: ["click"],
  data(){
    return {
      productImages: []
    }
  },
  computed: {
    imagenPrincipal(){
      return this.productImages.length
        ? this.productImages[0].pathBase64
        : imagenPorDefecto;
    },
    /** 250000 -> "250.000". Antes se mostraba el numero crudo. */
    precioFormateado(){
      const valor = Number(this.product.costs);

      if (this.product.costs === null || this.product.costs === undefined || isNaN(valor)){
        return 'Consultar';
      }
      return valor.toLocaleString('es-CO');
    }
  },
  created(){
    apisProducts.ImagesProducts(this.product.idProduct)
      .then(images => {
        this.productImages = images
      })
  }
};
</script>

<style scoped>
.btn-Product{
  width: 100%;
  height: 100%;
  padding: 0;
  border: 1px solid #e5e9f0;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-align: left;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}
.btn-Product:hover{
  cursor: pointer;
  border-color: #90caf9;
  box-shadow: 0 6px 16px rgba(25,118,210,0.15);
  transform: translateY(-2px);
}

/* Marco de proporcion fija: la imagen crece con la columna en vez de
   quedarse en una altura suelta que deja franjas vacias.
   La proporcion la impone la prop aspect-ratio del v-img y no CSS: dentro de
   un flex en columna el min-height:auto deja que la imagen imponga su alto
   natural y anule la regla de CSS. min-height:0 corta ese comportamiento. */
.marco-imagen{
  width: 100%;
  min-height: 0;
  flex-shrink: 0;
  overflow: hidden;
  background-color: #f1f5f9;
}
.imagen{
  width: 100%;
}
.cargando-imagen{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.cuerpo{
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 9px 10px 11px;
  flex: 1;
}

/* Dos lineas maximo: sin esto los nombres largos se cortaban con puntos
   suspensivos y las tarjetas quedaban de alturas distintas */
.titulo{
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.25;
  color: #111;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.precio{
  font-weight: 700;
  font-size: 1rem;
  color: #1976d2;
  line-height: 1.2;
}
.moneda{
  font-size: 0.7rem;
  font-weight: 600;
  color: #7a8ba0;
}
.descripcion{
  font-size: 0.78rem;
  line-height: 1.35;
  color: #6b7280;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (min-width: 500px){
  .titulo{
    font-size: 0.95rem;
  }
  .precio{
    font-size: 1.05rem;
  }
}
</style>
